// @ts-nocheck
import {Component, Inject, PLATFORM_ID, OnDestroy} from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent  implements OnDestroy{
  subscription: Subscription;

  // @ts-ignore
  constructor(@Inject(PLATFORM_ID) private platformId: any){
    AppComponent.isBrowser.next(isPlatformBrowser(platformId));
  }

  static isBrowser = new BehaviorSubject<boolean>(null);

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
